import store from "@/store";
import router from "@/router";
import { useGnbMenu } from "@/composables/useGnbMenu";

export default function useSessionHanlder() {
  const { getMenu } = useGnbMenu();
  const useSignout = () => {
    store.dispatch("auth/reset");
    store.dispatch("localStorage/removeLocalStorage");
  };

  const success = ({
    sessionToken,
    clientInfo,
    centerInfo,
    tos,
  }: vuex.sessionHandler) => {
    store.dispatch("auth/updateSessionToken", sessionToken);
    store.dispatch("auth/updateClientInfo", clientInfo);
    store.dispatch("auth/updateCenterInfo", centerInfo);
    store.dispatch("auth/updateMarketingAgreement", tos?.marketing ?? null);
    store.dispatch("localStorage/saveToLocalStorage");

    const firstOutboundURL = getMenu.value[0].children![0]
      ? getMenu.value[0].children![0].link
      : "/";

    const nextURL = sessionStorage.getItem("redirectURL");

    const redirectURL =
      nextURL === "/outbound/complete" ? firstOutboundURL : nextURL;

    return router.push(redirectURL ?? "/");
  };

  const failed = () => {
    useSignout();
    return router.push("/");
  };

  return {
    success,
    failed,
    useSignout,
  };
}
